function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
var uuidv4 = require('uuid/v4');

import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import './RXTree.css';
var _ = require('lodash');

var logdown = require('logdown');
var console = logdown('rx-forms-rx-tree', { prefixColor: '#0288d1' });

var mapValuesDeep = function mapValuesDeep(obj, fn) {
    return _.mapValues(obj, function (val, key) {
        return _.isPlainObject(val) ? mapValuesDeep(val, fn) : fn(val, key, obj);
    });
};

var checkDeep = function checkDeep(obj, fn) {

    if (_.isArray(obj)) {
        _.map(obj, function (val, key) {
            checkDeep(val, fn);
        });
    } else {
        fn(obj);
        if (obj.children) {
            checkDeep(obj.children, fn);
        }
    }
};

var RXTree = function (_Component) {
    _inherits(RXTree, _Component);

    function RXTree(props) {
        _classCallCheck(this, RXTree);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.updateSelectedValues = function () {

            var newData = _.cloneDeep(_this.state.data);
            checkDeep(newData, function (obj) {
                // console.log(obj.value)
                if (_.includes(_this.state.value, obj.value)) {
                    obj.checked = true;
                } else {
                    obj.checked = false;
                }
            });
            _this.setState({ data: newData });
        };

        _this.onChange = function (currentNode, selectedNodes) {

            console.log('onChange::', currentNode, selectedNodes);
            var newValues = _.map(selectedNodes, function (v, k) {
                return v.value;
            });
            console.log('newValues ', newValues);
            _this.setState({ value: newValues }, function () {
                return _this.doOnChange(newValues);
            });
        };

        _this.onAction = function (_ref) {
            var action = _ref.action,
                node = _ref.node;

            console.log('onAction:: [' + action + ']', node);
        };

        _this.onNodeToggle = function (currentNode) {
            console.log('onNodeToggle::', currentNode);
        };

        _this.doOnChange = function (values) {
            _this.props.onChange({ target: { value: values, id: _this.props.name } });
        };

        console.log('13000: ', _this.props);

        _this.state = {
            invalid: false,
            data: _this.props.data ? _this.props.data : { label: 'default label', value: 'default value' },
            value: _this.props.value && _this.props.value != undefined ? _this.props.value : _this.props.defaults ? _this.props.defaults : [],
            disabled: _this.props.disabled
        };
        console.log('after props: ', _this.props);
        console.log('after state: ', _this.state);

        return _this;
    }

    RXTree.prototype.componentDidMount = function componentDidMount() {

        this.updateSelectedValues();
        this.doOnChange(this.state.value);
    };

    RXTree.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this2 = this;

        if (this.props.data != prevProps.data) {
            this.setState({ data: this.props.data });
        }
        if (this.props.disabled != prevProps.disabled) {
            this.setState({ disabled: this.props.disabled });
        }
        if (this.props.value != prevProps.value) {
            console.log('try to update with ', this.props.value);
            this.setState({ value: this.props.value }, function () {
                return _this2.updateSelectedValues();
            });
        }
    };

    RXTree.prototype.render = function render() {

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(DropdownTreeSelect, { disabled: this.state.disabled, hierarchical: this.props.hierarchical, placeholderText: this.props.placeholderText, keepTreeOnSearch: this.props.keepTreeOnSearch, keepChildrenOnSearch: this.props.keepChildrenOnSearch, data: this.state.data, onChange: this.onChange, onAction: this.onAction, onNodeToggle: this.onNodeToggle, readOnly: this.props.readOnly })
        );
    };

    return RXTree;
}(Component);

RXTree.defaultProps = {
    placeholderText: "select",
    disabled: 0,
    hierarchical: 1,
    keepTreeOnSearch: 1,
    keepChildrenOnSearch: 1,
    readOnly: 0
};

export default RXTree;